// extracted by mini-css-extract-plugin
export var displayNone = "_ri-6";
export var imgContainer = "_ri-2";
export var overflowHidden = "_ri-3";
export var productInfoCardButtonContainer = "_ri-5";
export var productTitleText = "_ri-4";
export var rightArrow = "_ri-1";
export var rightArrowContainer = "_ri-0";